import {pluralize} from 'BenchlingUtil';

export function getShouldCloneLabelText(isBulk: boolean, sequencesToBeCreated: number): string {
  if (!isBulk) {
    return 'Create new entity with modifications';
  }

  return `Create (${sequencesToBeCreated}) new ${pluralize(
    sequencesToBeCreated,
    'entity'
  )} with modifications`;
}
